import Banner from "@/components/Banner/Banner";
import { CalculationStepType } from "./type";
import { dateFunc } from "@/components/Functions/dateFunc";
type CalculationStepHeaderProps = {
    create: boolean;
    selectedStep?: CalculationStepType;
    distributionId?: string;
    timeZone?: string;
    distributionName: string;
}

export default function CalculationStepHeaderEdit({
  create = false,
  selectedStep,
  distributionId = "",
  timeZone = "",
  distributionName
}: CalculationStepHeaderProps) {
  // const { data } = useGetDistributionSummaryByIdQuery(
  //   {
  //     id: distributionId,
  //   },
  //   { skip: create }
  // );
  const bannerElements: { label: string; value: string }[] = [
    {
      label:
        "pages.distributions.distributionStepsTab.stepBannerDetails.label1",
      value: `${distributionName || "-"}`,
    },{
      label:
        "pages.distributions.distributionStepsTab.stepBannerDetails.label3",
      value: `${selectedStep?.sortOrder}`,
    },
    {
      label:
        "pages.distributions.distributionStepsTab.stepBannerDetails.label2",
      value: `${
        selectedStep?.updatedOn ? 
        dateFunc(selectedStep?.updatedOn).formattedDateTime + " " + timeZone
        //formatDate(selectedStep?.updatedOn) 
        : "-"
      }`,
    },
  ];

  return (
    <div className="claim-details-header mar-b-20">
      <div className="claim-details-header__title">
        <Banner
          bannerName="pages.distributions.distributionStepsTab.stepBannerDetails.title"
          bannerNameValue={`${selectedStep?.stepName || "-"}`}
          elements={bannerElements}
        />
      </div>
    </div>
  );
}